module.exports = __webpack_public_path__ + "img/nginxwise5.53ff3907.png";